import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { documentTypes } from '@app/pages/cmms/components/files/document-type/document-type.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { Subject, takeUntil } from 'rxjs';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { FileTypes } from '@shared/ui-components/au-document-type/file-types';

import { AuDocumentTypeComponent } from '../../../../../../shared/ui-components/au-document-type/au-document-type.component';

//Backend (cmms-service) expects empty string for filter where entities have no docuemnt type.
//Must be empty string to enable ability to filter both entities with and without document type simultaneously.
const noDocumentType = '';

@Component({
	selector: 'file-document-type',
	templateUrl: './file-document-type-filter.component.html',
	styleUrls: ['./file-document-type-filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatCheckbox, AuDocumentTypeComponent],
})
export class FileDocumentTypeFilterComponent
	implements ICmmsFilterComponent, OnInit, OnDestroy
{
	private destroy$ = new Subject<void>();
	readonly documentTypes = [noDocumentType, ...documentTypes];
	selectionModel = new SelectionModel(true, []);

	@Input() data: {
		activePage: CmmsPages;
		columnName: string;
		preselectedValue: string[];
	};
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	ngOnInit() {
		this.selectionModel.changed.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.filterValueChanged.emit(
				this.generateFilterValue(this.selectionModel.selected)
			);
		});

		if (this.data.preselectedValue) {
			this.data.preselectedValue.forEach(option => {
				this.selectionModel.select(option);
			});
		}
	}

	isChecked(option: string) {
		return this.selectionModel.isSelected(option);
	}

	toggleSelection(evt: MatCheckboxChange, option: string) {
		if (evt.checked) {
			this.selectionModel.select(option);
		} else {
			this.selectionModel.deselect(option);
		}
	}

	generateFilterValue(options: string[]): {
		columnName: string;
		label: string;
		data: string[];
	} {
		/* Label should be in specific format that is needed to show it in filter button. */
		const label = [];
		const data = [];

		options.forEach(option => {
			label.push(FileTypes[option].name);
			data.push(option);
		});

		return {
			columnName: this.data.columnName,
			label: label.join('; '),
			data,
		};
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
